import { jsx as a } from "react/jsx-runtime";
import "react";
var l = (r) => /* @__PURE__ */ a("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...r,
  children: /* @__PURE__ */ a("path", {
    fill: "currentColor",
    d: "M5.165 15.666A1.167 1.167 0 0 1 3.998 14.5V5.167A1.167 1.167 0 0 1 5.165 4h9.334a1.167 1.167 0 0 1 1.167 1.167v9.332a1.167 1.167 0 0 1-1.167 1.167H5.165Zm16.336 0a1.167 1.167 0 0 1-1.167-1.167V5.167A1.167 1.167 0 0 1 21.5 4h9.332A1.167 1.167 0 0 1 32 5.167v9.332a1.167 1.167 0 0 1-1.167 1.167h-9.332ZM5.165 32.002a1.167 1.167 0 0 1-1.167-1.167V21.5a1.167 1.167 0 0 1 1.167-1.166h9.334a1.167 1.167 0 0 1 1.167 1.166v9.335a1.167 1.167 0 0 1-1.167 1.167H5.165Zm16.336 0a1.167 1.167 0 0 1-1.167-1.167V21.5a1.167 1.167 0 0 1 1.167-1.166h9.332A1.167 1.167 0 0 1 32 21.5v9.335a1.167 1.167 0 0 1-1.167 1.167h-9.332Z"
  })
});
export {
  l as default
};
